/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthResponse } from '../models/AuthResponse';
import type { EmailRequestRequest } from '../models/EmailRequestRequest';
import type { EmailVerifyRequest } from '../models/EmailVerifyRequest';
import type { SessionResponse } from '../models/SessionResponse';
import type { SuccessResponse } from '../models/SuccessResponse';
import type { TelegramAuthRequest } from '../models/TelegramAuthRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Request email sign-in code or link
     * @returns SuccessResponse Email auth flow requested
     * @throws ApiError
     */
    public static postApiV1AuthEmailRequest({
        requestBody,
    }: {
        requestBody: EmailRequestRequest,
    }): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/email/request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                429: `Rate limited`,
            },
        });
    }
    /**
     * Verify email sign-in token or code
     * @returns AuthResponse Authenticated session created
     * @throws ApiError
     */
    public static postApiV1AuthEmailVerify({
        requestBody,
    }: {
        requestBody: EmailVerifyRequest,
    }): CancelablePromise<AuthResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/email/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid or expired credential`,
            },
        });
    }
    /**
     * Authenticate with Telegram payload
     * @returns AuthResponse Authenticated session created
     * @throws ApiError
     */
    public static postApiV1AuthTelegram({
        requestBody,
    }: {
        requestBody: TelegramAuthRequest,
    }): CancelablePromise<AuthResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/telegram',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid Telegram auth payload`,
            },
        });
    }
    /**
     * Inspect current session
     * @returns SessionResponse Current session state
     * @throws ApiError
     */
    public static getApiV1AuthSession(): CancelablePromise<SessionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/auth/session',
        });
    }
    /**
     * Logout current session
     * @returns SuccessResponse Session cleared
     * @throws ApiError
     */
    public static postApiV1AuthLogout(): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/logout',
            errors: {
                401: `No active session`,
            },
        });
    }
}
